module.exports = __webpack_public_path__ + "static/media/022.6c8c8044.jpg";